import graphqlClient from "../../../apollo";

class StockTransactionProvider {

    findStockTransaction(id) {
        return graphqlClient.query({
            query: require('./gql/StockTransaction/findStockTransaction.graphql'),
            variables: {id:id}
        })
    }

    fetchStockTransaction() {
        return graphqlClient.query({
            query: require('./gql/StockTransaction/fetchStockTransaction.graphql')})
    }

    paginateStockTransaction(pageNumber, itemsPerPage, search = null, filters = null,  orderBy = null, orderDesc = false) {
        return graphqlClient.query({
            query: require('./gql/StockTransaction/paginateStockTransaction.graphql'),
            variables: {pageNumber, itemsPerPage, search, filters, orderBy, orderDesc},
            fetchPolicy: "no-cache"
        })
    }



    createStockTransaction(input) {
        return graphqlClient.mutate({
            mutation: require('./gql/StockTransaction/createStockTransaction.graphql'),
            variables: {input}
        })
    }

    updateStockTransaction(id,input) {
        return graphqlClient.mutate({
            mutation: require('./gql/StockTransaction/updateStockTransaction.graphql'),
            variables: {id, input}
        })
    }

    reverseStockTransaction(id) {
        return graphqlClient.mutate({
            mutation: require('./gql/StockTransaction/reverseStockTransaction.graphql'),
            variables: {id}
        })
    }

     deleteStockTransaction(id) {
        return graphqlClient.mutate({
            mutation: require('./gql/StockTransaction/deleteStockTransaction.graphql'),
            variables: {id}
        })
    }

}

export default new StockTransactionProvider()

